<template>
  <div>
    <el-form :model="searchForm" ref="searchFormRef" label-width="80px" v-show="searchBoxFlag">
      <el-row :gutter="24">
        <el-col span="6">
          <el-form-item label="班组名称" prop="checkPass">
            <el-input
              clearable
              v-model="searchForm.name"
              placeholder="设备编号"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item label="服务类型" prop="checkPass">
              <el-select v-model="searchForm.moduleType" placeholder="服务类型" style="width:100%">
                <el-option
                  v-for="item in inspectTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <div style="float:right">
            <el-button icon="el-icon-search" type="primary" @click="search" size="small"> 搜索 </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>


      </el-row>
    </el-form>
    <avue-crud
          :option="option"
          :table-loading="loading"
          :data="data"
          :page.sync="page"
          ref="crud"
          @on-load="onLoad"
          @selection-change="selectionChange"
          @current-change="currentChange"
          @size-change="sizeChange"
          @refresh-change="onLoad"
        >
        <!-- <template slot="menuRight">
              <searchFromShow
                :searchBoxFlag.sync='searchBoxFlag'
                :removeHeight ='searchHeight'
                :option='option'
                :refOption="$refs.crud"
                ></searchFromShow>

            </template> -->
          <!-- @on-load="search" -->
          <template slot="menuLeft">
            <div v-if="isShowMenuLeft">
              <el-button type="primary" size="small" @click="addRelateDevice">新 增</el-button>
              <el-button type="primary" size="small" @click="removeChoiceGroup"
                >移除选中</el-button
              >
              <el-button type="primary" size="small" @click="removeAllGroup">移除全部</el-button>
            </div>
          </template>

        </avue-crud>
    <hr-dialog
      title="选择班组"
      v-if="addRelateGroupFlag"
      :visible.sync="addRelateGroupFlag"

      width="80%"
      :handleClose="handleClose"
    >
    <template slot="body">
       <AddGroup @submitGroup="submitGroup" :row='row'></AddGroup>
    </template>

    </hr-dialog>
  </div>
</template>

<script>
import {
  getRelatedDevice,
  removeRelationDevice,
  lookStandardStopDevice,
} from '@/api/crmedical/device/deviceRelation';
import AddGroup from "./addGroup.vue"
import {getDictionary,getBisDictData,lookStandardGroup,removeGroup} from '@/api/crmedical/comprehensiveInspect/index.js'
import searchFromShow from '@/components/search-form-show/index'
export default {
  props: ['row','isShowMenuLeft'],
  components: {

    searchFromShow,AddGroup
  },
  data() {
    return {
      searchBoxFlag:true,
     searchHeight:'',
      groupIds: '',//选中的班组

      addRelateGroupFlag: false, //新增关联设备对话框
      searchForm: {

      },

      option: {
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: false,
        tip: false,
        border: true,
        index: true,
        selection: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        columnBtn: false,
        column: [
          {
            label: '班组名称',
            prop: 'name',
          },
          {
            label: '服务类型',
            prop: 'code',
          },
           {
            label: '责任人',
            prop: 'chargeManName',
          },

          {
            label: '班组成员',
            prop: 'purchasePrice',

          },


        ],
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      data: [],
    };
  },
  created() {
    console.log('1111', this.projectId);
    this.initData();
  },
  mounted() {
    this.calcHeight();
  },
  methods: {
    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 379;
    },

    searchClear() {
      this.searchForm = {

      };

    },

    search() {
      this.page.currentPage = 1;
      this.onLoad();
    },
    removeChoiceGroup() {
      console.log('设备');
      if (this.groupIds) {
        removeGroup({
          ids: this.groupIds,
          standardId: this.row.id,

        }).then(() => {
          this.$message.success('移除关联成功');
          this.onLoad();
        });
      } else {
        this.$message({
          showClose: true,
          message: '没有勾选任何班组',
          type: 'warning',
        });
        return;
      }
    },
    removeAllGroup() {
      if (this.page.total > 0) {

        removeGroup(
          {standardId: this.row.id,}
        ).then(() => {
          this.$message.success('移除所有关联班组');
          this.onLoad();
        });
      } else {
        this.$message({
          showClose: true,
          message: '没有可移除的班组',
          type: 'warning',
        });
        return;
      }
    },
    selectionChange(val) {
      console.log(val);
      let Ids = [];
      val.forEach((element) => {
        Ids.push(element.id);
      });
      this.groupIds = Ids.join(',');
    },
    addRelateDevice() {
      this.addRelateGroupFlag = true;
    },

    onLoad(page) {
      page = page || this.page;
      this.loading = true;
        lookStandardGroup(
          Object.assign(
            {},
            {
              current: this.page.currentPage,
              size: this.page.pageSize,
              standardId: this.row.id,
              projectId: this.row.projectId,
              status:this.row.status
            },
            this.searchForm
          )
        ).then(({ data }) => {
          this.data = data.records;
          this.page.total = data.total;
          this.loading = false;
        });
    },
    initData() {

    },

  },
};
</script>

<style scoped>
::v-deep .avue-crud .el-form-item {
  display: block;
}
/* ::v-deep .el-table--small {
  height: 330px!important;
} */
</style>
